import { render, staticRenderFns } from "./AkAddress.vue?vue&type=template&id=08d6604c&"
import script from "./AkAddress.vue?vue&type=script&lang=js&"
export * from "./AkAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/helden-van-de-keuken/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d6604c')) {
      api.createRecord('08d6604c', component.options)
    } else {
      api.reload('08d6604c', component.options)
    }
    module.hot.accept("./AkAddress.vue?vue&type=template&id=08d6604c&", function () {
      api.rerender('08d6604c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/AkAddress.vue"
export default component.exports